<template>
  <div>
    <div class="action">
      <div class="btn-group" role="group">
        <button class="btn btn-dark add" v-on:click="addWish()">
          <font-awesome-icon icon="plus" />
        </button>
        <button type="button" class="btn btn-dark" v-on:click="saveWishlist">
          <font-awesome-icon icon="save" />
        </button>
        <button type="button" class="btn btn-dark" v-on:click="refreshWishlist">
          <font-awesome-icon icon="sync-alt" />
        </button>
      </div>
    </div>

    <div v-for="wish in $piggyBank.data.wishlist" v-bind:key="wish.id">
      <div class="row wish-item">
        <Wish class="col" v-bind:wish="wish"></Wish>
        <div class="actions">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-dark"
              v-on:click="editWish(wish)"
            >
              <font-awesome-icon icon="pencil-alt" />
            </button>
            <button
              type="button"
              class="btn btn-dark"
              v-on:click="delWish(wish)"
            >
              <font-awesome-icon icon="trash-alt" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalQuestion ref="question"></ModalQuestion>
    <WishEdit ref="wish"></WishEdit>
  </div>
</template>

<script>
export default {
  methods: {
    refresh() {
      this.$emit("refresh", this.wishlist);
    },
    addWish(newWish) {
      let wish = newWish || this.$piggyBank.data.newWish();

      this.$refs.wish
        .show(wish)
        .then((result) => {
          this.$piggyBank.data.wishlist.push(result);
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    editWish(wish) {
      this.$refs.wish
        .show(wish)
        .then((result) => {
          let index = this.$piggyBank.data.wishlist.indexOf(wish);
          this.$piggyBank.data.wishlist[index] = result;
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    delWish(wish) {
      this.$refs.question
        .ask("Czy usunąć życzenie")
        .then(() => {
          let index = this.$piggyBank.data.wishlist.indexOf(wish);
          this.$piggyBank.data.wishlist.splice(index, 1);
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    saveWishlist() {
      this.$piggyBank.data.saveWishlist();
    },
    refreshWishlist() {
      this.$piggyBank.data.refreshWishlist();
    },
    swipeHandler(event) {
      console.log(arguments);
    },
  },
};
</script>

<style lang="scss" scoped>
.wish-item {
  background: #0003;
  // background: red;
  // justify-items: center;
  margin: 2px 0px;
  padding: 2px;
  border-radius: 5px;
  // border-top: 1px solid gray;
  display: flex;
  justify-content: center;
  align-items: center;

  &.child {
    background: #0001;
  }

  .mobile & {
    .actions {
      display: none;
    }
  }
}
</style>